import utils from '@utils';
import cacheSystem from '@utils/cacheSystem';
import { isEmpty, get, isUndefined } from 'lodash';
import { goBack } from 'react-router-redux';
import configureStore from '@redux-core';
import GlobalsActions from '@redux/globals';

/**
 * Function to validate if the user
 * is Client
 *
 * @param {Object} user
 */
export const isUserClient = (user) => (user.UserTypeId === 20);

/**
 * Function to udpate any progressButton
 * on any redux module
 */
export const updateProgressButton = ({
	dispatch,
	module,
	property,
	value,
}) => {
	dispatch(GlobalsActions.changeState(module, property, value));

	// Prevent clean up if it's loading
	if (value === 'loading') return;

	// Clean progressButton after a 1000ms to let component finish the animation
	setTimeout(() => dispatch(GlobalsActions.changeState(module, property, '')), 1000);
};

export const apiErrorHandler = ({
	dispatch,
	module = 'app',
	property = 'loading',
	usingProgressButton = false,
	navigateBack = false,
	defaultError = 'Error retriving data',
}) => (error) => {
	let message = defaultError;

	message = get(error, 'response.data.ErrorMessage');
	message = !message ? get(error, 'response.data.Message') : message;
	message = !message ? get(error, 'response.data.message') : message;
	message = !message ? get(error, 'message') : message;
	message = !message ? get(error, 'Message') : message;

	// Stop loading animation
	if (!isUndefined(dispatch)) {
		// Stop loading animation
		if (!usingProgressButton) dispatch(GlobalsActions.changeState(module, property, false));
		else {
			updateProgressButton({
				dispatch, module, property, value : 'error',
			});
		}
	}

	if (navigateBack) dispatch(goBack());

	// Fire Error Notification
	utils.notify({
		type  : 'error',
		title : 'Error',
		message,
	});
};

export const getNewJobStatus = ({ Status }) => {
	const result = { value : Status };
	if ((Status === 'PendingReview') || (Status === 'Amended') || (Status === 'PendingPayment') || (Status === 'PaymentProcessing')) result.label = 'warning';
	else if ((Status === 'PaymentRejected') || (Status === 'Disputed') || (Status === 'Cancelled')) result.label = 'danger';
	else result.label = 'success';
	return result;
};

export const getRestrictionDescription = ({
	RequestedJurisdictionCity,
	RequestedJurisdictionCounty,
	RequestedJurisdictionExpiresBefore,
	RequestedJurisdictionName,
	OfficerRequirements,
}) => {
	let description = '';
	let addComma = false;

	if (RequestedJurisdictionCity) {
		description = `Officers from ${RequestedJurisdictionCity} city`;
		addComma = true;
	}

	if (RequestedJurisdictionCounty) {
		description += `${addComma ? ', ' : ''}Officers from ${RequestedJurisdictionCounty} county`;
		addComma = true;
	}

	if (RequestedJurisdictionExpiresBefore) {
		description += `${addComma ? ', ' : ''}Jurisdiction expires before ${RequestedJurisdictionExpiresBefore}`;
		addComma = true;
	}

	if (RequestedJurisdictionName) {
		description += `${addComma ? ', ' : ''}Officer from ${RequestedJurisdictionName} jurisdiction`;
		addComma = true;
	}

	if (OfficerRequirements) {
		description += `${addComma ? ', ' : ''}${OfficerRequirements}`;
		addComma = true;
	}

	if (isEmpty(description)) description = 'None';

	return description;
};

export const getCityStateZipString = (city, state, zipcode) => {
	let address = '';

	if (city) address += `${city}, `;

	if (state) address += `${state} `;

	if (zipcode) address += zipcode;

	return address;
};

export const clearReduxStoreAndLocalStorage = () => {
	configureStore().persistor.purge().then(() => {
		cacheSystem.getInstance().clear();
	});
};

export default {
	isUserClient,
	updateProgressButton,
	apiErrorHandler,
	getRestrictionDescription,
	getCityStateZipString,
	getNewJobStatus,
	clearReduxStoreAndLocalStorage,
};
